import { ComponentProps, FC, useContext } from 'react'
import { styled } from '../../../config'
import { Close as CloseIcon } from '../../../icons'
import { IconButton } from '../../IconButton'
import { ModalContext } from '../ModalContext'

const StyledIconButton = styled(IconButton, {
  position: 'absolute',
  right: '10px',
  top: '10px',
  '& > svg': { width: '16px', height: '16px' }
})

export const Close: FC<ComponentProps<typeof StyledIconButton>> = (props) => {
  const { onClose } = useContext(ModalContext)

  return (
    <StyledIconButton onClick={onClose} variant="ghostInverted" {...props}>
      <CloseIcon />
    </StyledIconButton>
  )
}
